export default __webpack_public_path__ + "media/src/features/listing-agent-match-on-hdp/assets/slpIcon-f0c5520449d2c24ab3a5ec133a240199.svg";